import { useState, useEffect, useRef, useCallback } from "react";
import { ToastContainer } from "react-bootstrap";
import jwtDecode from "jwt-decode";
import axios from "axios";
import { getPercentageOrAmount } from "../../../utils/getPercentageOrAmount.js";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import { rest } from "lodash";

export const useOrderDetails = ({
  title,
  restaurant,
  // onUpdateServiceCharge,
  selectedTable,
  setSelectedTable,
  selectedOkTable,
  setIsToggleOn,
  isToggleOn,
  DeliverySelfCollectionState,
  isServiceChargeEnabled: parentIsServiceChargeEnabled,
  handleServiceChargeToggle: parentHandleServiceChargeToggle,
}) => {
  const [modalShow, setModalShow] = useState(false);
  const [tableModalShow, setTableModalShow] = useState(false);
  const [clickedRestaurant, setClickedRestaurant] = useState("");
  const [orderType, setOrderType] = useState("");
  const [cartData, setCartData] = useState([]);
  const [selectOk, setselecteOk] = useState([]);
  const [totalSd, setTotalSd] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const [totalVatOnSd, setTotalVatOnSd] = useState(0);
  const [subTotalAmount, setSubTotalAmount] = useState(0);
  const [serviceCharge, setServiceCharge] = useState(0);
  const [serviceChargeVat, setServiceChargeVat] = useState(0);
  // Use parent's service charge state if provided, otherwise use local state
  const [localIsServiceChargeEnabled, setLocalIsServiceChargeEnabled] =
    useState(true);
  const isServiceChargeEnabled =
    parentIsServiceChargeEnabled !== undefined
      ? parentIsServiceChargeEnabled
      : localIsServiceChargeEnabled;
  // const [isToggleOn, setIsToggleOn] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showCollectionTag, setShowCollectionTag] = useState(false);
  const [toggleStateForNotCollection, setToggleStateForNotCollection] =
    useState(false);
  const array = [];

  const notificationShown = useRef(false);
  const [storedSwitchedItems, setStoredSwitchedItems] = useState([]);
  const [isAccordionExpanded, setIsAccordionExpanded] = useState(false);

  const handleShowTableModal = (restaurantId) => {
    setClickedRestaurant(restaurantId);
    setTableModalShow(true);
  };

  // const handleShowModal = (restaurantName, order) =>{
  //     setModalShow(true);
  //     setClickedRestaurant(restaurantName);
  //     setOrderType(order);
  // }

  useEffect(() => {
    selectedOkTable((prev) => [...(prev || []), ...selectOk]);
  }, [selectOk]);

  useEffect(() => {
    const calculateTotals = () => {
      let totalBasePrice = 0;
      let fooditemVat = 0;
      let foodItemSd = 0;
      let foodItemVatOnSd = 0;

      let totalAddonPrice = 0;
      let totalAddonSD = 0;
      let totalAddonVat = 0;
      let totalAddonVatOnSd = 0;

      let totalOptionPrice = 0;
      let totalOptionVat = 0;
      let totalOptionSD = 0;
      let totalOptionVatOnSd = 0;

      let totalSubOptionPrice = 0;
      let totalSubOptionSd = 0;
      let totalSubOptionVat = 0;
      let totalSubOptionVatOnSd = 0;

      restaurant.subOrders
        .filter((subOrder) => subOrder.orderTypeName === title)
        .forEach((subOrder) => {
          // Calculating Total price, vat and sd of foodItem
          subOrder.itemDetails.forEach((item) => {
            totalBasePrice =
              totalBasePrice + item.basePrice * item.foodItemQuantity;
            fooditemVat += item.vatInAmount * item.foodItemQuantity;
            foodItemSd += item.sdInAmount * item.foodItemQuantity;
            foodItemVatOnSd += item.vatOnSdInAmount * item.foodItemQuantity;

            // Calculating Total price, vat and sd of AddOn
            item.addOns.forEach((addOn) => {
              totalAddonPrice += addOn.addOnBasePrice * addOn.addOnQuantity;
              totalAddonVat += addOn.addOnVatAmount * addOn.addOnQuantity;
              totalAddonSD += addOn.addOnSdAmount * addOn.addOnQuantity;
              totalAddonVatOnSd +=
                addOn.addOnVatOnSdAmount * addOn.addOnQuantity;

              // Calculating Total price, vat and sd of Option
              addOn.options.forEach((option) => {
                totalOptionPrice +=
                  option.optionBasePrice * option.optionQuantity;
                totalOptionVat +=
                  option.optionVatAmount * option.optionQuantity;
                totalOptionSD += option.optionSdAmount * option.optionQuantity;
                totalOptionVatOnSd +=
                  option.optionVatOnSdAmount * option.optionQuantity;

                // Calculating Total price, vat and sd of SubOption
                option.subOptions.forEach((subOption) => {
                  totalSubOptionPrice +=
                    subOption.subOptionBasePrice * subOption.subOptionQuantity;
                  totalSubOptionSd +=
                    subOption.subOptionSdAmount * subOption.subOptionQuantity;
                  totalSubOptionVat +=
                    subOption.subOptionVatAmount * subOption.subOptionQuantity;
                  totalSubOptionVatOnSd +=
                    subOption.subOptionVatOnSdAmount *
                    subOption.subOptionQuantity;
                });
              });
            });
          });
        });

      const totalVatAmount =
        fooditemVat + totalAddonVat + totalOptionVat + totalSubOptionVat;
      const totalSdAmount =
        foodItemSd + totalAddonSD + totalOptionSD + totalSubOptionSd;
      const totalVatOnSdAmount =
        foodItemVatOnSd +
        totalAddonVatOnSd +
        totalOptionVatOnSd +
        totalSubOptionVatOnSd;

      setTotalVat(totalVatAmount);
      setTotalSd(totalSdAmount);
      setTotalVatOnSd(totalVatOnSdAmount);
      setSubTotalAmount(
        totalBasePrice +
          totalAddonPrice +
          totalOptionPrice +
          totalSubOptionPrice
      );
    };

    calculateTotals();
  }, [restaurant, title]);

  useEffect(() => {
    // Initialize service charge toggle based on isServiceChargeCom
    if (parentIsServiceChargeEnabled === undefined) {
      // Only initialize local state if parent state is not provided
      if (restaurant?.isServiceChargeCom === false) {
        setLocalIsServiceChargeEnabled(true); // Default ON when false
      } else if (restaurant?.isServiceChargeCom === true) {
        setLocalIsServiceChargeEnabled(true); // Always ON when true
      }
    }
  }, [restaurant, parentIsServiceChargeEnabled]);

  useEffect(() => {
    if (title === "In-Store" && isServiceChargeEnabled) {
      const vatAmount = getPercentageOrAmount(
        subTotalAmount,
        restaurant?.serviceCharge,
        "amount"
      );

      setServiceCharge(vatAmount);

      // Calculate Service Charge VAT (20%)
      const serviceChargeVatAmount = getPercentageOrAmount(
        vatAmount,
        20,
        "amount"
      );

      setServiceChargeVat(serviceChargeVatAmount);
      // onUpdateServiceCharge(vatAmount);
    } else {
      setServiceCharge(0);
      setServiceChargeVat(0);
      // onUpdateServiceCharge(0);
    }
  }, [restaurant, subTotalAmount, isServiceChargeEnabled, title]);

  const Total = () => {
    return (
      subTotalAmount +
      totalSd +
      totalVat +
      totalVatOnSd +
      0 +
      serviceCharge +
      serviceChargeVat
    );
  };

  const TotalAfterCredit = () => {
    if (
      subTotalAmount +
        totalSd +
        totalVat +
        totalVatOnSd +
        0 +
        serviceCharge +
        serviceChargeVat >=
      restaurant?.minimumOrderPriceToGiveCredit
    ) {
      return (
        subTotalAmount +
        totalSd +
        totalVat +
        totalVatOnSd +
        0 +
        serviceCharge +
        serviceChargeVat -
        restaurant.creditLimitPerOrder
      );
    } else {
      return (
        subTotalAmount +
        totalSd +
        totalVat +
        0 +
        serviceCharge +
        serviceChargeVat
      );
    }
  };

  useEffect(() => {
    const userId = localStorage.getItem("gotasteClienttoken");
    const decoded = jwtDecode(userId);

    const getCartData = async (userId) => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SECRET}/api/Cart/GetCartDataByUserId?userId=${userId}`
        );
        setCartData(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    getCartData(decoded.UserId);
  }, []);

  // useEffect(() => {
  //   restaurant.subOrders.forEach((subOrder) => {
  //     if (subOrder.orderTypeName === "Delivery") {
  //       // Check all items inside itemDetails
  //       const allItemsMatch = subOrder.itemDetails.every(
  //         (item) => item.isDelivery === true && item.isCollectionOnly === true
  //       );

  //       // const allItemsMatch = true;

  //       setIsDisabled(allItemsMatch); // Disable only if all items match
  //       if (allItemsMatch) {
  //         setIsToggleOn(true); // Force ON when disabled
  //         toast.info("Items for self-collection");
  //       }
  //     }
  //   });
  // }, [restaurant]);

  const ShowDeliveryNotification = (subOrder) => {
    const allItemsMatch = subOrder.itemDetails.every(
      (item) =>
        item.isDelivery === true &&
        item.isDeliveryOff === false &&
        item.isCollectionOnly === true
    );

    if (allItemsMatch) {
      if (!isDisabled) setIsDisabled(true);
      if (!isToggleOn) setIsToggleOn(true);

      if (!notificationShown.current) {
        toast.info("Items for self-collection");
        notificationShown.current = true;
      }
    }
  };

  useEffect(() => {
    if (restaurant !== null) {
      restaurant?.subOrders
        .filter((subOrder) => subOrder.orderTypeName === "Delivery")
        .forEach(ShowDeliveryNotification);
    }
  }, [restaurant]);

  // const handleToggle = (usedFor, subOrder) => {
  //   if (usedFor === "NotCollection") {
  //     DeliverySelfCollectionState(subOrder);

  //     setStoredSwitchedItems((prevItems) => {
  //       const existingItem = prevItems.find(
  //         (item) => item.subOrderId === subOrder.subOrderId
  //       );

  //       if (existingItem) {
  //         return prevItems.map((item) =>
  //           item.subOrderId === subOrder.subOrderId
  //             ? { ...item, active: !item.active }
  //             : item
  //         );
  //       } else {
  //         return [
  //           ...prevItems,
  //           { subOrderId: subOrder.subOrderId, active: true },
  //         ];
  //       }
  //     });
  //   }
  // };

  // handle toggle with API calls
  const handleToggle = (usedFor, subOrder) => {
    if (usedFor === "NotCollection") {
      DeliverySelfCollectionState(subOrder);
      setStoredSwitchedItems((prevItems) => {
        const existingItem = prevItems.find(
          (item) => item.subOrderId === subOrder.subOrderId
        );
        const newState = existingItem ? !existingItem.active : true;

        // ✅ If toggling ON → Self-Collection (active = true), DELETE delivery address
        if (newState === true) {
          // Toggle ON = Self-Collection → delete delivery binding
          axios
            .delete(
              `${process.env.REACT_APP_SECRET}/api/Cart/DeleteDeliveryAddress?subOrderId=${subOrder.subOrderId}`
            )
            .catch((error) => {
              console.error("Failed to delete delivery address:", error);
              toast.error("Failed to remove delivery info");
            });
        }
        // ✅ If toggling OFF → Delivery (active = false), re-create delivery+table data
        else if (newState === false) {
          // Reconstruct minimal reqObj for InsertIntoDeliverAddressAndTable
          // Mimic structure used in CheckOut.jsx `transformApiResponse` + usage
          const userId = localStorage.getItem("gotasteClienttoken")
            ? jwtDecode(localStorage.getItem("gotasteClienttoken")).UserId
            : null;

          if (!userId) {
            console.warn("User ID not found; skipping delivery re-creation.");
            return prevItems.map((item) =>
              item.subOrderId === subOrder.subOrderId
                ? { ...item, active: false }
                : item
            );
          }

          // Build reqObj — same as in CheckOut.jsx useEffect
          const transformedData = {
            userId: userId,
            restaurantIds: [
              {
                restaurantId: restaurant.cartRestaurantId,
                foodItemIds: subOrder.itemDetails.map((item) => ({
                  foodItemId: item.foodItemId,
                })),
              },
            ],
          };

          axios
            .post(
              `${process.env.REACT_APP_SECRET}/api/Cart/InsertIntoDeliverAddressAndTable`,
              transformedData
            )
            .catch((error) => {
              console.error(
                "Failed to re-create delivery address binding:",
                error
              );
              toast.error("Failed to restore delivery info");
            });
        }

        // Update state
        if (existingItem) {
          return prevItems.map((item) =>
            item.subOrderId === subOrder.subOrderId
              ? { ...item, active: newState }
              : item
          );
        } else {
          return [
            ...prevItems,
            { subOrderId: subOrder.subOrderId, active: newState },
          ];
        }
      });
    }
  };

  const handleServiceChargeToggle = useCallback(() => {
    // Only allow toggle if isServiceChargeCom is false
    if (restaurant?.isServiceChargeCom === false) {
      if (parentHandleServiceChargeToggle) {
        // Use parent handler if provided
        parentHandleServiceChargeToggle();
      } else {
        // Use local state if no parent handler
        setLocalIsServiceChargeEnabled((prevState) => !prevState);
      }
    }
  }, [parentHandleServiceChargeToggle, restaurant, isServiceChargeEnabled]);

  // if (!isDisabled) {
  //   setIsToggleOn(!isToggleOn);
  // }

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor: "#1890ff",
          ...theme.applyStyles("dark", {
            backgroundColor: "#177ddc",
          }),
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: "rgba(0,0,0,.25)",
      boxSizing: "border-box",
      ...theme.applyStyles("dark", {
        backgroundColor: "rgba(255,255,255,.35)",
      }),
    },
  }));

  console.log("zzza", selectOk?.tableName, selectedTable?.tableName);

  return {
    modalShow,
    setModalShow,
    tableModalShow,
    setTableModalShow,
    clickedRestaurant,
    setClickedRestaurant,
    cartData,
    selectOk,
    setselecteOk,
    totalSd,
    totalVat,
    totalVatOnSd,
    subTotalAmount,
    serviceCharge,
    serviceChargeVat,
    isServiceChargeEnabled,
    isDisabled,
    storedSwitchedItems,
    AntSwitch,
    handleShowTableModal,
    handleToggle,
    handleServiceChargeToggle,
    Total,
    TotalAfterCredit,
    isAccordionExpanded,
    setIsAccordionExpanded,
  };
};
